import { UseFormHandleSubmit } from "react-hook-form";

interface Props {
  activeTab: string;
  tabs: {
    id: string;
    label: string;
    component: React.ReactNode;
  }[];
  handleSubmit: UseFormHandleSubmit<any>;
  onSubmit: (data: any) => void;
}

export default function ProfileForm({
  activeTab,
  tabs,
  handleSubmit,
  onSubmit
}: Props) {
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="universaleditmodal-right">
      {tabs.find(tab => tab.id === activeTab)?.component}
    </form>
  );
}